.outageBannerContainer {
  width: 100%;
  height: 100%;
  overflow: auto;

  >div:first-child {
    display: flex;
    flex-direction: column;
    align-items: center;

    >svg {
      margin: 2rem 0 1rem 0;
    }

    >h1:nth-child(4) {
      letter-spacing: 1px;
      word-spacing: 5px;
      font-weight: 600;
      margin-bottom: 1.1rem;
    }

    >p:nth-child(5),
    >p:nth-child(6),
    >p:nth-child(7) {
      margin-top: 0.4rem;
      font-size: 1.1rem;
    }

    >p:nth-child(5),
    >p:nth-child(6) {
      color: #949FAE;
    }

    >p:nth-child(7) {
      color: #94A3B8;
    }
  }
}